export * from './ng4-files-click.component';



// WEBPACK FOOTER //
// ./src/app/shelf/Clouddata/ng4-files/components/ng4-files-click/index.ts